<script setup lang="ts">
import { GalleryVerticalEnd as GalleryVerticalEndIcon, Library as LibraryIcon } from '@lucide/vue'

const props = withDefaults(
  defineProps<{
    compact?: boolean
  }>(),
  {
    compact: false,
  },
)

const emit = defineEmits<{
  'go-library': []
  'go-collections': []
}>()
</script>

<template>
  <div
    data-testid="pinned-empty-state"
    :class="[
      'rounded-lg border border-emerald-200 bg-emerald-50/70 text-gray-900 shadow-sm',
      props.compact ? 'p-3' : 'p-4',
    ]"
  >
    <div class="min-w-0">
      <h3
        :class="[
          'font-semibold tracking-tight text-gray-950',
          props.compact ? 'text-sm' : 'text-base',
        ]"
      >
        Plan, navigate, and curate in Pinned
      </h3>
      <p :class="['text-gray-600', props.compact ? 'text-xs leading-5' : 'text-sm leading-6']">
        Pin activities, routes, points of interest, and entire Collections for quick access
        here<span v-if="props.compact">. Long-press or swipe on items to pin.</span
        ><span v-else>.</span>
      </p>
    </div>

    <div :class="['mt-3 grid grid-cols-2 gap-2', props.compact ? '' : 'sm:flex sm:flex-wrap']">
      <button
        type="button"
        class="inline-flex items-center justify-center gap-1.5 rounded-md border border-emerald-200 bg-white px-2.5 py-2 text-xs font-medium text-gray-800 transition hover:cursor-pointer hover:bg-emerald-100/70"
        @click="emit('go-library')"
      >
        <LibraryIcon class="h-3.5 w-3.5 text-emerald-700" />
        <span>Library</span>
      </button>
      <button
        type="button"
        class="inline-flex items-center justify-center gap-1.5 rounded-md border border-emerald-200 bg-white px-2.5 py-2 text-xs font-medium text-gray-800 transition hover:cursor-pointer hover:bg-emerald-100/70"
        @click="emit('go-collections')"
      >
        <GalleryVerticalEndIcon class="h-3.5 w-3.5 text-emerald-700" />
        <span>Collections</span>
      </button>
    </div>
  </div>
</template>
